<template>
  <div class="main">
    <c-panel title="Suspensões de leitores" titleIcon="fas fa-user-lock">
      <!--
        Itens 15 e 16 do edital. A suspensão NUNCA nasce sozinha: a lista de atrasos abaixo
        apenas sinaliza e abre o formulário já preenchido — quem suspende é uma pessoa.
      -->
      <el-tabs v-model="aba">
        <el-tab-pane label="Suspensões" name="lista">
          <el-row :gutter="10" class="u-mb-15">
            <el-col :xs="24" :sm="8">
              <el-select v-model="filtro.instituicao_id" placeholder="Instituição" clearable
                         @change="load" style="width:100%" filterable>
                <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="8">
              <el-checkbox v-model="filtro.vigentes" @change="load">Somente vigentes</el-checkbox>
            </el-col>
            <el-col :xs="24" :sm="8" class="u-text-right">
              <el-button @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
            </el-col>
          </el-row>

          <table class="table table-striped">
            <thead>
              <tr>
                <th>Leitor</th>
                <th class="hidden-mobile" style="width:90px;">Tipo</th>
                <th style="width:105px;">Início</th>
                <th style="width:120px;">Fim</th>
                <th>Motivo</th>
                <th class="hidden-mobile">Instituição</th>
                <th style="width:105px;" class="u-text-center">Situação</th>
                <th style="width:100px;" class="u-text-center" v-if="podeSuspender">Ação</th>
              </tr>
            </thead>
            <tbody v-if="statusList">
              <tr v-for="s in items" :key="s.id">
                <td>{{ s.leitor_nome || ('#' + s.leitor_id) }}</td>
                <td class="hidden-mobile">{{ (s.leitor_tipo || '').toUpperCase() }}</td>
                <td>{{ formatarData(s.data_inicio) }}</td>
                <td>{{ s.data_fim ? formatarData(s.data_fim) : 'indeterminado' }}</td>
                <td>{{ s.motivo }}</td>
                <td class="hidden-mobile">{{ s.instituicao_nome || '—' }}</td>
                <td class="u-text-center">
                  <el-tag v-if="s.data_revogacao" type="info" size="mini">revogada</el-tag>
                  <el-tag v-else-if="s.vigente" type="danger" size="mini">vigente</el-tag>
                  <el-tag v-else type="warning" size="mini">encerrada</el-tag>
                </td>
                <td class="u-text-center" v-if="podeSuspender">
                  <el-button v-if="!s.data_revogacao && s.vigente" @click="abrirRevogacao(s)"
                             title="Desfazer suspensão" type="success" icon="el-icon-refresh-left"
                             size="mini" plain></el-button>
                  <span v-else class="u-fs-12">—</span>
                </td>
              </tr>
              <tr v-if="items.length === 0">
                <td :colspan="podeSuspender ? 8 : 7" class="u-text-center">Nenhuma suspensão registrada.</td>
              </tr>
            </tbody>
          </table>
        </el-tab-pane>

        <!-- ============ Atrasos: sinaliza, não pune ============ -->
        <el-tab-pane :label="'Atrasos (' + atrasos.length + ')'" name="atrasos">
          <el-alert type="warning" show-icon :closable="false" class="u-mb-15"
                    title="Atraso não gera suspensão automática"
                    description="Esta lista existe para que alguém decida. Nenhuma suspensão é criada pelo sistema.">
          </el-alert>

          <table class="table table-striped">
            <thead>
              <tr>
                <th>Leitor</th>
                <th>Material</th>
                <th class="hidden-mobile" style="width:110px;">Exemplar</th>
                <th style="width:130px;">Devolver até</th>
                <th style="width:100px;" class="u-text-center">Atraso</th>
                <th style="width:130px;" class="u-text-center" v-if="podeSuspender">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="a in atrasos" :key="a.id">
                <td>{{ a.leitor_nome || ('#' + a.usuario_id) }}</td>
                <td>{{ a.titulo }}</td>
                <td class="hidden-mobile">{{ a.codigo }}</td>
                <td>{{ formatarData(a.data_prevista_devolucao) }}</td>
                <td class="u-text-center"><el-tag type="danger" size="mini">{{ a.dias_atraso }} dia(s)</el-tag></td>
                <td class="u-text-center" v-if="podeSuspender">
                  <el-tag v-if="a.ja_suspenso" type="info" size="mini">já suspenso</el-tag>
                  <el-button v-else @click="abrirSuspensaoDoAtraso(a)" type="danger" size="mini" plain>
                    SUSPENDER
                  </el-button>
                </td>
              </tr>
              <tr v-if="atrasos.length === 0">
                <td :colspan="podeSuspender ? 6 : 5" class="u-text-center">Nenhum empréstimo em atraso.</td>
              </tr>
            </tbody>
          </table>
        </el-tab-pane>
      </el-tabs>

      <el-dialog title="Suspender leitor" :visible.sync="dialogSuspender" width="560px" append-to-body>
        <el-alert v-if="alvo" type="info" :closable="false" show-icon class="u-mb-15"
                  :title="alvo.leitor_nome"
                  :description="'Motivado pelo atraso de \"' + alvo.titulo + '\" — ' + alvo.dias_atraso + ' dia(s).'">
        </el-alert>
        <el-form label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12">
              <el-form-item label="Início *">
                <el-date-picker v-model="form.data_inicio" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="Fim (em branco = indeterminado)">
                <el-date-picker v-model="form.data_fim" type="date" value-format="yyyy-MM-dd"
                                format="dd/MM/yyyy" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24">
              <el-form-item label="Motivo *"><el-input v-model="form.motivo" maxlength="191"></el-input></el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogSuspender = false">CANCELAR</el-button>
          <el-button class="u-ml-10" type="danger" @click="suspender" :loading="salvando">SUSPENDER</el-button>
        </span>
      </el-dialog>

      <el-dialog title="Desfazer suspensão" :visible.sync="dialogRevogar" width="520px" append-to-body>
        <el-alert type="info" :closable="false" show-icon class="u-mb-15"
                  title="A suspensão não é apagada"
                  description="Fica registrada como revogada, com data e motivo.">
        </el-alert>
        <el-form label-position="top">
          <el-form-item label="Motivo da revogação *">
            <el-input v-model="formRev.motivo_revogacao" maxlength="191"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogRevogar = false">CANCELAR</el-button>
          <el-button class="u-ml-10" type="success" @click="revogar" :loading="salvando">DESFAZER</el-button>
        </span>
      </el-dialog>
    </c-panel>
  </div>
</template>

<script>
export default {
  components: { cPanel: () => import('@/shared/c-panel/c-panel.vue') },

  data: () => ({
    aba: 'lista',
    statusList: false, salvando: false,
    items: [], atrasos: [], instituicoes: [],
    filtro: { instituicao_id: '', vigentes: false },
    dialogSuspender: false, dialogRevogar: false,
    form: {}, formRev: {}, alvo: null, suspensaoAlvo: null
  }),

  computed: {
    podeSuspender () { return [0, 1, 4, 5, 12].indexOf(Number(this.$store.state.user.tipo)) !== -1 },
    base () { return `${this.$store.state.config.baseUrlApi}/api/biblioteca` }
  },

  mounted () {
    this.instituicoes = this.$store.state.instituicoes || []
    this.load()
    this.carregarAtrasos()
  },

  methods: {
    formatarData (d) { return d ? this.$moment(d).format('DD/MM/YYYY') : '—' },

    load () {
      this.statusList = false
      this.$axios.post(`${this.base}/suspensao/getAllPaginate`, this.filtro, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.statusList = true
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.items = r.data.data || []
        }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
    },

    carregarAtrasos () {
      this.$axios.post(`${this.base}/suspensao/atrasos`, {}, this.$store.getters.getHeaderAuth)
        .then(r => { this.atrasos = (r.data && !r.data.erro) ? (r.data.itens || []) : [] })
        .catch(() => { this.atrasos = [] })
    },

    /** Abre o formulário JÁ PREENCHIDO — mas quem confirma é o operador. */
    abrirSuspensaoDoAtraso (a) {
      this.alvo = a
      this.form = {
        data_inicio: this.$moment().format('YYYY-MM-DD'),
        data_fim: '',
        motivo: `Atraso na devolução de "${a.titulo}" (${a.dias_atraso} dia(s)).`,
        leitor_tipo: a.usuario_tipo, leitor_id: a.usuario_id,
        instituicao_id: a.instituicao_id, emprestimo_id: a.id
      }
      this.dialogSuspender = true
    },

    suspender () {
      if (!this.form.motivo) {
        return window.eventBus.$emit('alert', { msg: 'Informe o motivo da suspensão.', type: 'warning' })
      }
      this.salvando = true
      this.$axios.post(`${this.base}/suspensao/suspender`, this.form, this.$store.getters.getHeaderAuth)
        .then(r => {
          this.salvando = false
          if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
          this.dialogSuspender = false
          window.eventBus.$emit('alert', { msg: 'Leitor suspenso.', type: 'success' })
          this.load(); this.carregarAtrasos()
        }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
    },

    abrirRevogacao (s) {
      this.suspensaoAlvo = s
      this.formRev = { motivo_revogacao: '' }
      this.dialogRevogar = true
    },

    revogar () {
      if (!this.formRev.motivo_revogacao) {
        return window.eventBus.$emit('alert', { msg: 'Informe o motivo da revogação.', type: 'warning' })
      }
      this.salvando = true
      this.$axios.post(`${this.base}/suspensao/revogar/${this.suspensaoAlvo.id}`, this.formRev,
                       this.$store.getters.getHeaderAuth).then(r => {
        this.salvando = false
        if (r.data && r.data.erro) return window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
        this.dialogRevogar = false
        window.eventBus.$emit('alert', { msg: 'Suspensão revogada.', type: 'success' })
        this.load(); this.carregarAtrasos()
      }).catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
    }
  }
}
</script>
